<script lang="ts">
import { type PropType, defineComponent } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export default defineComponent({
  props: {
    route: {
      type: [String, Object] as PropType<RouteLocationRaw>,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultClass:
        'rounded-full border-2 border-slate-800 bg-transparent px-3 py-1 text-sm font-bold text-slate-800',
    }
  },
})
</script>

<template>
  <!-- @vue-skip  -->
  <RouterLink v-if="route" :to="route" :title="text" :class="defaultClass">
    {{ text }}
  </RouterLink>
</template>
